import React from "react";

export const PromptContext = React.createContext();
export const PromptDispatchContext = React.createContext();

function PromptProvider({children}) {
    const [state,setstate] = React.useState(null)
    return(
        <PromptContext.Provider value={state}>
            <PromptDispatchContext.Provider value={setstate} >
                {children}
            </PromptDispatchContext.Provider>
        </PromptContext.Provider>
    )
}

export {PromptProvider};
